import React from 'react';
import {Input, Select, Form, Modal, DatePicker,Upload,message,Button,Icon,Col,Row} from 'antd';
import moment from 'moment';


const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}

const formLargeItemLayout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 19,
  },
}

const modalMaster = ({visible,onCancel,type,item = {},onOk,form: {getFieldDecorator,validateFields},}) => {
	function handleOk () {
		validateFields((err, values) => {
			if(err){return }
			console.log(values)
			onOk(values);
		})

	}

	const modalOpts = {
	  title: '取消订单',
	  visible,
	  onOk: handleOk,
	  onCancel:onCancel,
	  wrapClassName: 'vertical-center-modal',
	  width: 520,
	  okText: '同意',
	  //footer:null
	}
	return (
	  <Modal {...modalOpts}>	  
		<Form layout="horizontal">
		<Form.Item label={'id'} {...formItemLayout}  hidden={true}>
			{getFieldDecorator('id', {
					initialValue: item.id,
				}
			)(
				<Input />
			)}
		</Form.Item>
		<Form.Item label={'取消意见'} {...formItemLayout} >
			{getFieldDecorator('cancel_reason', {
					initialValue: item.cancel_reason,
				}
			)(
				<Input />
			)}
		</Form.Item>
		{/*<Row>*/}
		{/*	<Col span={4}   ><Button type='primary' onClick={handleOk}>同意</Button></Col>*/}
		{/*</Row>*/}
		</Form>
	  </Modal>
	)
}
const ModalRender = Form.create()(modalMaster);
export default ModalRender;
